//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import MenuSub from "./menu-sub.vue";
import MenuItem from "./menu-item.vue";
import mobileMenu from "./mobile-menu.vue";

import menuDatas from "./menu.json";
import menuBlog from "./menu-blog.vue";
import { filterDownloadMenu } from '../../../../tools/tools';

export default {
  name: "",
  components: {
    MenuSub,
    MenuItem,
    mobileMenu,
    menuBlog,
  },
  props: {
    theme: {
      type: String,
      default: '',
    },
    isTikTokChannel: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      showSub: "-1",
    };
  },
  methods: {
    openSub(id) {
      this.showSub = id;
    },
    closeSub() {
      if (this.showSub) {
        this.showSub = "";
      }
    },
    closeMenu() {
      this.$emit("closeMenu");
    },
  },
  computed: {
    datas() {
      const menuConfig = this.isTikTokChannel ? filterDownloadMenu(menuDatas) : menuDatas;
      return menuConfig;
    }
  },
  mounted() {
    document.addEventListener("click", this.closeSub);
  },
};
